import { SolicitudesService } from './../../../services/solicitudes/solicitudes.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { DatePipe} from "@angular/common";
import Swal from "sweetalert2";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesDates } from '../../../models/messages';
import { Router } from '@angular/router';
import 'rxjs/add/observable/of';
import { FiltrosSolicitudes } from 'app/models/FiltrosSolicitudes';


export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

declare var $: any;

@Component({
  selector: 'app-listado-quejas-reclamos',
  templateUrl: './listado-quejas-reclamos.component.html',
  styleUrls: ['./listado-quejas-reclamos.component.scss'],
  providers: [MessagesTitles,MessagesGeneral,MessagesDates,
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class ListadoQuejasReclamosComponent implements OnInit {

  DTOFiltrosSolicitudes: FiltrosSolicitudes = new FiltrosSolicitudes();
  loading:boolean;
  data :any = [];
  idLiquidacion: number = 0;
  reclamos : any = [];
  user:any;
  FechaIni: Date = new Date();
  FechaFin: Date = new Date();
  Fecha=moment();
  form : FormGroup;
  abrirPopUp:boolean = false;
  abrirDetalleReclamo:boolean = false;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  pageSizeOptions = [15,20,30,50,100,200];
  displayedColumns=[ 'checked','diferencia','idSolicitud','Codigo','NombresCompletos','ApellidoPaterno','ApellidoMaterno','NroDocumentoIdentidad','Email','TelefonoMovil','FechaRegistro','TipoSolicitud','Estado']
  dataSource: any;

  constructor(private datePipe:DatePipe,private router:Router,private solicitudService:SolicitudesService) {
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.FechaIni.setDate(this.FechaIni.getDate()-60);
    
    this.form = new FormGroup({
      idSolicitud: new FormControl('', [Validators.required]),
      Estado:new FormControl('', [Validators.required]),
    });
   }

   calcularDias(fechaRegistro:any){
     return this.Fecha.diff(fechaRegistro, 'days')
   }
   calcularDiasA(fechaAtencion:any){
    return this.Fecha.diff(fechaAtencion, 'days')
  }

  ngOnInit() {
    this.ListadoReclamoFiltro()
  }

  tipoSolicitud(event){
    this.DTOFiltrosSolicitudes.TipoSolicitud = event;
  }

  ListadoReclamoFiltro(){
    this.loading = true;
    this.solicitudService.FiltroListadoReclamos(this.DTOFiltrosSolicitudes,this.datePipe.transform(this.FechaIni,'yyyyMMdd'),this.datePipe.transform(this.FechaFin,'yyyMMdd')).subscribe(
      res =>{
          this.reclamos = res;
          this.dataSource = new MatTableDataSource( this.reclamos);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          this.loading = false;
      },err =>{
          Swal.fire({
              title: "¡Algo salió mal!",
              text:  err.error['error'],
              type: "warning",
              allowOutsideClick: true,
              heightAuto: false 
          });
          this.loading = false;
      }
    )
  }

cerrar(idSolicitud:any){
  Swal.fire({
    title: '',
    text: '¿Estás seguro de cerrar la solicitud '+idSolicitud+'?',
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Si, cerrar solicitud',
    cancelButtonText: 'No, cancelar.',
    reverseButtons: true,
    heightAuto: false
  }).then((result) => {
    if (result.value) {
      this.form.controls['idSolicitud'].setValue(idSolicitud);
      this.form.controls['Estado'].setValue('C');
      this.solicitudService.actualizarEstado(this.form.getRawValue())
      .subscribe(res => { 
        Swal.fire({
          title: '¡Solicitud cerrada!',
          text: res["message"],
          type: 'success',
          heightAuto: false
        }).then(res1 => {
          if (res1.value == true) {
            this.ListadoReclamoFiltro();
          }
        });
  
      })
    } else if (
      result.dismiss === Swal.DismissReason.cancel
    ) {
      this.loading = false;
    }
  })
}

abrir(idSolicitud:any){
  Swal.fire({
    title: '',
    text: '¿Estás seguro de abrir la solicitud '+idSolicitud+'?',
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Si, abrir solicitud',
    cancelButtonText: 'No, cancelar.',
    reverseButtons: true,
    heightAuto: false
  }).then((result) => {
    if (result.value) {
      this.form.controls['idSolicitud'].setValue(idSolicitud);
      this.form.controls['Estado'].setValue('E');
      this.solicitudService.actualizarEstado(this.form.getRawValue())
      .subscribe(res => { 
        Swal.fire({
          title: 'Solicitud abierta!',
          text: res["message"],
          type: 'success',
          heightAuto: false
        }).then(resp => {
          if (resp.value == true) {
            this.ListadoReclamoFiltro();
          }
        });
  
      })
    } else if (
      result.dismiss === Swal.DismissReason.cancel
    ) {
      this.loading = false;
    }
  })
}

AbrirDetalleReclamo(element:any){
 this.solicitudService.datos = element;
 this.abrirDetalleReclamo = true;
}

AbrirPopUp(element:any){
  this.solicitudService.datos = element;
  this.abrirPopUp = true;
}
CerrarPopUp(){
  this.abrirPopUp = false;
}

CerrarPopUpDetalle(){
  this.abrirDetalleReclamo = false;
}

}
